import React from "react";
import EntryColor from "../container/EntryColor";

const FlatViewExacta = ({
  charts,
  getOpenBetsChartModal,
  idExacta,
  showBetsColumnExacta,
  setSelectionsSelected,
}) => {
  var tableContent = [],
    headers;

  if (charts) {
    tableContent = charts.map((chart, i) => {
      let selections = chart.Selections.split(",");
      return (
        <tr key={i}>
          <td>
            <EntryColor
              entryNum={parseInt(selections[0])}
              saddleNum={selections[0]}
            />
          </td>
          <td>
            <EntryColor
              entryNum={parseInt(selections[1])}
              saddleNum={selections[1]}
            />
          </td>
          <td style={{ fontWeight: "bold", verticalAlign: "middle" }}>
            ${chart.Amount.toFixed(2)}
          </td>
          {showBetsColumnExacta && (
            <td
              style={{ verticalAlign: "middle" }}
              className="cantBets"
              data-toggle="modal"
              data-target="#openBetsChartModal"
              onClick={() => {
                getOpenBetsChartModal(idExacta, chart.Selections);
                setSelectionsSelected(chart.Selections);
              }}
            >
              {chart.BetCount}
            </td>
          )}
        </tr>
      );
    });
  }

  headers = (
    <tr className="text-center">
      <th>1ST LEG</th>
      <th>2ND LEG</th>
      <th>Money</th>
      {showBetsColumnExacta && <th># Bets</th>}
    </tr>
  );

  return (
    <>
      <table className="table table-striped table-sm mt-2">
        <thead>{headers}</thead>
        <tbody className="table-sm text-center table-bordered">
          {tableContent}
        </tbody>
      </table>
    </>
  );
};

export default FlatViewExacta;
